import {TransportAssocEntity, transportCategory, TransportCategory} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Image, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {TransportDetails} from "./TransportDetails";
import {useMemo} from "react";
import {Empty} from "../../empty/Empty/Empty";
import {TicketTimeline} from "../../timeline/TicketTimeline/TicketTimeline";

export type TicketDetailsProps = {
  ticket: TransportAssocEntity
}

const TicketType = (props: { category: TransportCategory }) => {
  const {category} = props

  const {t} = useTranslation(["common"])

  const iconProps = useMemo(() => {
    if (category === transportCategory.oil) {
      return {
        app: "OilGo",
        url: import.meta.env.BASE_URL + "ic_oilgo.svg"
      }
    } else {
      return {
        app: "WaterGo",
        url: import.meta.env.BASE_URL + "ic_watergo.svg"
      }
    }
  }, [category])

  return (
    <Group spacing="xs">
      <Text ta="left" c="dimmed" fz="xs">
        {t(category.displayValue.id, category.displayValue.defaultMessage) + " (captured using " + iconProps.app + ")"}
      </Text>
      <Image width={24} height={24} src={iconProps.url}/>
    </Group>
  )
}

export const TicketDetails = (props: TicketDetailsProps) => {
  const {ticket} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={8}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.ticket.info.section.details.label", "Details")}</Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.ticket.info.field.id.label", "ID")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {ticket.resourceIdentifiers.join()}
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("profile.ticket.info.field.type.label", "Type")}
              </Text>
              <TicketType category={ticket.category}/>
            </Grid.Col>
            <Grid.Col span={12}>
              <Grid>
                <Grid.Col span={6}>
                  <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <Text ta="left" fz="sm" weight={900} mt="md">
                      {t("profile.ticket.info.field.pickup.label", "Pickup")}
                    </Text>
                    {ticket.pickupTransport ? <TransportDetails transport={ticket.pickupTransport}/> :
                      <Empty message={"No Details"}/>}
                  </Card>
                </Grid.Col>
                <Grid.Col span={6}>
                  <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <Text ta="left" fz="sm" weight={900} mt="md">
                      {t("profile.ticket.info.field.delivery.label", "Delivery")}
                    </Text>
                    {ticket.deliveryTransport ? <TransportDetails transport={ticket.deliveryTransport}/> :
                      <Empty message={"No Details"}/>}
                  </Card>
                </Grid.Col>
              </Grid>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
      <Grid.Col span={4}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{t("profile.ticket.info.section.timeline.label", "Timeline")}</Title>
          </Group>

          <Divider/>

          <TicketTimeline
            ticket={ticket}
            m="md"
            bulletSize={24}
            lineWidth={2}/>
        </Card>
      </Grid.Col>
    </Grid>
  );
};

